export default {"src":"/_next/static/media/cricket-ground.68ff10a9.svg","height":548,"width":588,"blurWidth":0,"blurHeight":0};